<!--
 * @Author: DY
 * @Date: 2025-03-05 15:40:48
 * @LastEditTime: 2026-03-27 15:03:39
 * @Description: 汽运单登记表单【运输管理-汽运单】
 * @FilePath: \ShiMo_Mobile\src\views\transport\automobileWaybillRegistration\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="automobileWaybillRegistrationForm commonFormStyles">
            <HeaderNav
                :header-title="`${transportTypeNmae}发货单`"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <van-tabs class="currencyTabsStyle" v-model="tabActive">
                <van-tab title="基本信息" name="1">
                    <div class="formList">
                        <van-collapse v-model="activeCollapseItem">
                            <van-collapse-item title="基本信息" name="1">
                                <van-field
                                    disabled
                                    label="汽运单号"
                                    placeholder="自动生成"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.TransportNumber"
                                ></van-field>
                                <template v-if="formData.TransportType == 2">
                                    <van-field
                                        readonly
                                        label="铁运单号"
                                        placeholder="请选择铁运单"
                                        :disabled="formData.Status != 0 || isView"
                                        :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                        v-model="formData.RailwayNumber"
                                        @click="selectRailwayNumber"
                                    ></van-field>
                                </template>
                                <van-field
                                    readonly
                                    label="发货通知单"
                                    placeholder="请选择发货通知单"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.DeliveryNoticeNumber"
                                    @click="selectDeliveryNotice"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="合同编号"
                                    placeholder="请选择发货通知单"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.ContractNo"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="客户名称"
                                    placeholder="请选择发货通知单"
                                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                    v-model="formData.ClientName"
                                ></van-field>
                                <van-field
                                    label="收货地址"
                                    placeholder="收货地址"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_3@2x.png')"
                                    v-model="formData.Address"
                                ></van-field>
                                <van-field
                                    label="签收人"
                                    placeholder="签收人"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                    v-model="formData.ClientContacts"
                                ></van-field>
                                <van-field
                                    label="联系电话"
                                    placeholder="联系电话"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_9@2x.png')"
                                    v-model="formData.ClientContactsPhone"
                                ></van-field>
                                <van-field
                                    readonly
                                    label="物料代码"
                                    placeholder="请选择物料"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                                    v-model="formData.MaterialCode"
                                    @click="selectMaterial"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="短描述"
                                    placeholder="请选择物料"
                                    :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                                    v-model="formData.MaterialShortName"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="长描述"
                                    placeholder="请选择物料"
                                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                                    v-model="formData.MaterialName"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="单位"
                                    placeholder="请选择物料"
                                    :left-icon="require('@/assets/images/icons/icon_24@2x.png')"
                                    v-model="formData.MaterialUnit"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="运输方式"
                                    placeholder="请选择物料"
                                    :left-icon="require('@/assets/images/icons/icon_11@2x.png')"
                                    v-model="transportTypeNmae"
                                ></van-field>
                            </van-collapse-item>
                            <van-collapse-item name="2">
                                <template #title>
                                    <span>汽运信息</span>
                                </template>
                                <van-field
                                    label="车牌号"
                                    placeholder="车牌号"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                    v-model="formData.PlateNumber"
                                ></van-field>
                                <van-field
                                    readonly
                                    label="发货日期"
                                    placeholder="请选择发货日期"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                    v-model="formData.DeliveryDate"
                                    @click="selectDate"
                                ></van-field>
                                <van-field
                                    label="司机"
                                    placeholder="司机"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                    v-model="formData.DriverName"
                                ></van-field>
                                <van-field
                                    label="司机电话"
                                    placeholder="司机电话"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_9@2x.png')"
                                    v-model="formData.DriverPhone"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="登记人"
                                    placeholder="登记人"
                                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                                    v-model="formData.Creator"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="登记时间"
                                    placeholder="登记时间"
                                    :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                                    v-model="formData.CreationTime"
                                ></van-field>
                                <van-field
                                    type="number"
                                    label="发货数量（吨）"
                                    placeholder="发货数量"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                                    v-model="formData.DeliveryWeightNew"
                                ></van-field>
                                <van-field
                                    type="number"
                                    label="进场皮重（吨）"
                                    placeholder="进场皮重"
                                    :disabled="![0, 4].includes(formData.Status) || isView"
                                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                                    v-model="formData.DeliveryTareWeight"
                                    @change="netWeightCalculation"
                                ></van-field>
                                <van-field
                                    type="number"
                                    label="出场毛重（吨）"
                                    placeholder="出场毛重"
                                    :disabled="![0, 4].includes(formData.Status) || isView"
                                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                                    v-model="formData.DeliveryGrossWeight"
                                    @change="netWeightCalculation"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="出场净重（吨）"
                                    placeholder="出场净重（吨）"
                                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                                    v-model="formData.DeliveryNetWeight"
                                ></van-field>
                                <van-field
                                    disabled
                                    label="出库数量（吨）"
                                    placeholder="出库数量（吨）"
                                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                                    v-model="formData.DeliveryWeight"
                                ></van-field>
                                <van-field
                                    label="备注"
                                    type="textarea"
                                    :rows="2"
                                    :disabled="formData.Status != 0 || isView"
                                    :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                                    v-model="formData.Remarks"
                                ></van-field>
                            </van-collapse-item>
                        </van-collapse>
                    </div>
                </van-tab>
                <van-tab title="发货明细" name="2">
                    <ul class="commonListStyles list" :class="{'no_data': (formData.TransportTruckCards || []).length === 0}">
                        <li class="listItem" v-for="(item,index) in formData.TransportTruckCards" :key="`item_${index}`">
                            <div class="engineeringInfo">
                                <h4 class="itemTitle">
                                    <span class="iconfont iconhetong">产品卡号：{{ item.ProductCardNumber }}</span>
                                </h4>
                                <div class="itemContent">
                                    <p>
                                        <img src="@/assets/images/icons/icon_46@2x.png" alt="">
                                        <span>物料代码：{{ item.MaterialCode }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                        <span>短描述：{{ item.MaterialShortName }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                        <span>生产部门/车间：{{ item.ProductWorkshopName }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                        <span>生产日期：{{ item.ProductDate }}</span>
                                    </p>
                                    <p>
                                        <img src="@/assets/images/icons/icon_16@2x.png" alt="">
                                        <span>单包重量：{{ item.PackageSingleWeight }}</span>
                                    </p>
                                </div>
                                <div class="itemBtn itemBtns" v-if="formData.Status == 0 && !isView">
                                    <van-button plain type="danger" @click="deleteTransportTruckCards(index)">
                                        删除
                                    </van-button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="btns" v-if="formData.Status == 0 && formData.TransportType != 1 && !isView">
                        <button class="iconfont sm-saoma" @click="addProductCard_QRCode"></button>
                        <button class="iconfont sm-icon-test" @click="addProductCard"></button>
                    </div>
                </van-tab>
            </van-tabs>
            <footer class="currencyFooterStyle">
                <template v-if="formData.Status == 0 && !isView">
                    <button class="confirm" @click="handleSubmit">
                        提交
                    </button>
                    <button class="confirm" @click="handleSave">
                        保存
                    </button>
                </template>
                <template v-if="formData.Status == 4 && !isView">
                    <button class="confirm" @click="confirmAppearance">
                        确认出场
                    </button>
                </template>
                <button class="confirm" @click="swiperright">
                    关闭
                </button>
            </footer>
            <van-calendar v-model="showCalendar" :min-date="minDate" :default-date="defaultDate" @confirm="confirmSelectDate"></van-calendar>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import { HeaderNav } from '@/components/';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);

export default {
    // 库位表单
    name: 'automobile-waybill-registration-form',
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.name !== 'selectListView') {
                vm.backPathName = from.name;
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === this.backPathName) {
            this.$store.commit('noKeepAlive', 'automobile-waybill-registration-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            backPathName: '',
            activeCollapseItem: ['1', '2'],
            tabActive: '1',
            formData: {
                Id: '',
                TransportId: '',
                TransportNumber: '',
                RailwayId: '',
                RailwayNumber: '',
                DeliveryNoticeId: '',
                DeliveryNoticeNumber: '',
                ContractNo: '',
                ContractNumber: '',
                ClientId: '',
                ClientName: '',
                CountryCode: '',
                CountryName: '',
                ProvinceCode: '',
                ProvinceName: '',
                CityCode: '',
                CityName: '',
                Address: '',
                ClientContacts: '',
                ClientContactsPhone: '',
                MaterialCode: '',
                MaterialName: '',
                MaterialShortName: '',
                MaterialUnit: '',
                MaterialPrice: 0,
                MaterialTaxRate: 0,
                DeliveryDate: null,
                PlateNumber: '',
                DriverName: '',
                DriverPhone: '',
                DeliveryWeightNew: '',
                DeliveryTareWeight: '',
                DeliveryGrossWeight: '',
                Remarks: '',
                Status: 0,
                TransportType: null,
                TransportTruckCards: [],
                ChoosedProductCards: [],
            },
            showCalendar: false,
            defaultDate: null,
            minDate: new Date(2000, 0, 1),
            transportTypeNmae: '',
            isSaveOperation: false,
            isView: false,
        };
    },
    computed: {},
    watch: {},
    async activated() {
        if (this.$route.params.railwayNumber) {
            const railwayNumber = this.$route.params.railwayNumber[0];
            this.formData.RailwayId = railwayNumber.id;
            this.formData.RailwayNumber = railwayNumber.transport_number;
            if (railwayNumber.notice_count === 1) {
                const res = await this.getFormDataRequrst_ty(railwayNumber.id);
                this.loadDeliveryNotice(res);
            } else {
                // 需要清空的字段数组
                const clearFields = [
                    'DeliveryNoticeId', 'DeliveryNoticeNumber', 'ContractNo', 'ContractNumber',
                    'ClientId', 'ClientName', 'CountryCode', 'CountryName',
                    'ProvinceCode', 'ProvinceName', 'CityCode', 'CityName',
                    'Address', 'ClientContacts', 'ClientContactsPhone', 'DeliveryDate',
                ];
                // 批量清空字段
                clearFields.forEach(field => { this.formData[field] = ''; });
            }
            // 清空物料相关字段（原有逻辑保持不变）
            this.formData.MaterialCode = '';
            this.formData.MaterialName = '';
            this.formData.MaterialShortName = '';
            this.formData.MaterialUnit = '';
            this.formData.MaterialPrice = '';
            this.formData.MaterialTaxRate = '';
        }
        if (this.$route.params.deliveryNotice) {
            const deliveryNotice = this.$route.params.deliveryNotice[0];
            this.loadDeliveryNotice(deliveryNotice);
        }
        if (this.$route.params.material) {
            const material = this.$route.params.material[0];
            const materialMappings = {
                material_code: 'MaterialCode',
                material_name: 'MaterialName',
                material_short_name: 'MaterialShortName',
                material_unit: 'MaterialUnit',
                material_price: 'MaterialPrice',
                material_tax_rate: 'MaterialTaxRate',
            };
            Object.entries(materialMappings).forEach(([srcKey, targetKey]) => {
                if (material.hasOwnProperty(srcKey)) {
                    this.formData[targetKey] = material[srcKey];
                }
            });
        }
        if (this.$route.params.productCard) {
            const productCard = this.$route.params.productCard;
            productCard.forEach(item => {
                this.formData.TransportTruckCards.push({
                    ProductCardNumber: item.product_card_number,
                    MaterialCode: item.material_code,
                    MaterialShortName: item.material_short_name,
                    ProductWorkshopName: item.product_workshop_name,
                    ProductDate: item.product_date,
                    PackageSingleWeight: item.package_single_weight,
                });
            });
            this.formData.ChoosedProductCards = this.formData.TransportTruckCards.map(item => item.ProductCardNumber);
            this.formData.DeliveryWeight = ((this.formData.TransportTruckCards || [])
                .map(item => item.PackageSingleWeight) || [])
                .reduce((pre, cur) => { return NP.plus(pre || 0, cur || 0); }, 0);
        }
    },
    created() {
        window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished_qyddj;
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            if (this.isSaveOperation) {
                this.closeForm();
            } else {
                this.$router.isBack = 1;
                this.$router.go(-1);
            }
        },
        async initpage() {
            this.$toast.loading({ overlay: true, duration: 0 });
            this.openType = this.$route.params.type;
            if (this.openType !== 'add') {
                const id = this.$route.params.data.id || this.$route.params.data.Id || '';
                this.isView = this.$route.params.isView || false;
                this.formData = await this.getFormDataRequrst_qy(id);
                if (this.$route.params.TransportType !== '1') {
                    this.formData.ChoosedProductCards = (this.formData.TransportTruckCards || []).map(item => item.ProductCardNumber) || [];
                }
            } else {
                this.formData.Creator = this.$takeTokenParameters('Name');
                this.formData.DeliveryDate = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd');
                this.formData.CreationTime = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
            }
            this.formData.TransportType = this.$route.params.TransportType;
            this.transportTypeNmae = this.formData.TransportType === '1' ? '汽运' : '铁运+汽运';
            this.$toast.clear();
        },
        selectRailwayNumber() {
            if (this.formData.Status !== 0) { return; }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择铁运单',
                    sourcePath: 'automobileWaybillRegistrationForm',
                    listCode: 'choose_transport_railway_signed',
                    callbackDataKey: 'railwayNumber',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '铁运单号',
                        code: 'transport_number',
                        isTitle: true,
                    }, {
                        name: '95306运单号',
                        code: 'number_95306',
                        icon: 'icon_1@2x',
                    }, {
                        name: '车种车号',
                        code: 'railway_type_number',
                        icon: 'icon_18@2x',
                    }, {
                        name: '客户名称',
                        code: 'client_names',
                        icon: 'icon_8@2x',
                    }, {
                        name: '物料名称',
                        code: 'material_short_names',
                        icon: 'icon_1@2x',
                    }, {
                        name: '发货数量(吨)',
                        code: 'delivery_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '发站',
                        code: 'leave_station',
                        icon: 'icon_3@2x',
                    }, {
                        name: '到站',
                        code: 'arrive_station',
                        icon: 'icon_3@2x',
                    }, {
                        name: '登记人',
                        code: 'creator',
                        icon: 'icon_8@2x',
                    }, {
                        name: '登记时间',
                        code: 'creation_time',
                        icon: 'icon_7@2x',
                    }],
                },
            });
        },
        selectDeliveryNotice() {
            if (this.formData.Status !== 0) { return; }
            if (this.formData.TransportType === '2' && (this.formData.RailwayNumber || '') === '') {
                this.$toast('请先选择铁运单！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择发货通知单',
                    sourcePath: 'automobileWaybillRegistrationForm',
                    listCode: 'truck_choose_delivery_notice',
                    callbackDataKey: 'deliveryNotice',
                    requestUrl: `/basicplatform/tabledata?railway_number=${this.formData.RailwayNumber}`,
                    relationKey: 'DeliveryNoticeId',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '发货通知单',
                        code: 'DeliveryNoticeNumber',
                        isTitle: true,
                    }, {
                        name: '合同编号',
                        code: 'ContractNo',
                        icon: 'icon_1@2x',
                    }, {
                        name: '客户名称',
                        code: 'ClientName',
                        icon: 'icon_29@2x',
                    }, {
                        name: '单据日期',
                        code: 'bill_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '发货日期',
                        code: 'DeliveryDateFormat',
                        icon: 'icon_7@2x',
                    }, {
                        name: '运输方式',
                        code: 'CodeTitle',
                        icon: 'icon_11@2x',
                    }, {
                        name: '发货数量',
                        code: 'delivery_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '签收人',
                        code: 'ClientContacts',
                        icon: 'icon_8@2x',
                    }, {
                        name: '联系电话',
                        code: 'ClientContactsPhone',
                        icon: 'icon_9@2x',
                    }, {
                        name: '备注',
                        code: 'remarks',
                        icon: 'icon_10@2x',
                    }],
                },
            });
        },
        selectMaterial() {
            if (this.formData.Status !== 0) { return; }
            if ((this.formData.DeliveryNoticeNumber || '') === '') {
                this.$toast('请先选择发货通知单');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择物料',
                    sourcePath: 'automobileWaybillRegistrationForm',
                    listCode: 'choose_delivery_notice_material_single',
                    callbackDataKey: 'material',
                    requestUrl: `/basicplatform/tabledata?delivery_notice_id=${this.formData.DeliveryNoticeId}&transport_id=${this.formData.RailwayId}`,
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '物料代码',
                        code: 'material_code',
                        isTitle: true,
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '长描述',
                        code: 'material_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '物料单位',
                        code: 'material_unit',
                        icon: 'icon_2@2x',
                    }, {
                        name: '合同数量（吨）',
                        code: 'contract_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '已发货数量（吨）',
                        code: 'already_delivery_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '未发货数量（吨）',
                        code: 'not_delivery_weight',
                        icon: 'icon_6@2x',
                    }],
                },
            });
        },
        loadDeliveryNotice(deliveryNotice) {
            // 使用遍历简化属性赋值
            Object.keys(deliveryNotice).forEach(key => {
                if (Object.prototype.hasOwnProperty.call(this.formData, key)) {
                    this.formData[key] = deliveryNotice[key];
                }
            });
            // 特殊处理地址字段（字段名不一致的情况）
            this.formData.Address = deliveryNotice.DeliveryAddress;
        },
        selectDate() {
            this.defaultDate = this.formData.DeliveryDate ? new Date(this.formData.DeliveryDate) : new Date();
            this.showCalendar = true;
        },

        confirmSelectDate(val) {
            this.formData.DeliveryDate = currencyFun.timeFormat(new Date(val), 'yyyy-MM-dd');
            this.showCalendar = false;
        },
        netWeightCalculation() {
            this.$set(this.formData, 'DeliveryNetWeight',
                NP.minus(
                    Number(this.formData.DeliveryGrossWeight) || 0,
                    Number(this.formData.DeliveryTareWeight) || 0
                )
            );
        },
        // 添加产品卡
        addProductCard() {
            if (this.formData.Status !== 0) { return; }
            if ((this.formData.RailwayNumber || '') === '') {
                this.$toast('请先选择铁运单！');
                return;
            }
            if ((this.formData.MaterialCode || '') === '') {
                this.$toast('请先选择物料！');
                return;
            }
            const selectedCards = (this.formData.TransportTruckCards || []).map(card => card.ProductCardNumber).join(',');
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '添加产品卡',
                    sourcePath: 'automobileWaybillRegistrationForm',
                    listCode: 'choose_railway_product_card',
                    callbackDataKey: 'productCard',
                    type: 'checkbox',
                    requestUrl: `/basicplatform/tabledata?railway_number=${this.formData.RailwayNumber}&delivery_notice_id=${this.formData.DeliveryNoticeId}&material_code=${this.formData.MaterialCode}&selectedCards=${selectedCards}`,
                    relationKey: 'id',
                    pageSize: 100,
                    indexKey: 'page',
                    sizeKey: 'limit',
                    showTotal: true,
                    totalKey: 'package_single_weight',
                    headerList: [{
                        name: '产品卡号',
                        code: 'product_card_number',
                        isTitle: true,
                    }, {
                        name: '产品卡批次号',
                        code: 'batch_number',
                        icon: 'icon_5@2x',
                    }, {
                        name: '生产车间',
                        code: 'product_workshop_name',
                        icon: 'icon_45@2x',
                    }, {
                        name: '生产日期',
                        code: 'product_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '单包重量(吨)',
                        code: 'package_single_weight',
                        icon: 'icon_16@2x',
                    }, {
                        name: '内部标识',
                        code: 'sign_internal',
                        icon: 'icon_41@2x',
                    }],
                },
            });
        },
        // 添加产品卡（扫码）
        addProductCard_QRCode() {
            if ((this.formData.RailwayNumber || '') === '') {
                this.$toast('请先选择铁运单！');
                return;
            }
            if ((this.formData.MaterialCode || '') === '') {
                this.$toast('请先选择物料！');
                return;
            }
            this.$callMobile('JYExternalNative', 'jyDriveScanClick');
        },
        async jyCallback_DriveScanFinished_qyddj(val) {
            const data = JSON.parse(`${val}`.slice(1, -1));
            const res = await this.getProductCardInfo(this.formData.MaterialCode, encodeURIComponent(data.ProductCardNumber));
            if (res) {
                this.formData.TransportTruckCards.push({
                    ProductCardNumber: res.ProductCardNumber,
                    MaterialCode: res.MaterialCode,
                    MaterialShortName: res.MaterialShortName,
                    ProductWorkshopName: res.ProductWorkshopName,
                    ProductDate: res.ProductDate,
                    PackageSingleWeight: res.PackageSingleWeight,
                });
                this.formData.ChoosedProductCards = this.formData.TransportTruckCards.map(item => item.ProductCardNumber);

                this.formData.DeliveryWeight = ((this.formData.TransportTruckCards || [])
                    .map(item => item.PackageSingleWeight) || [])
                    .reduce((pre, cur) => { return NP.plus(pre || 0, cur || 0); }, 0);
            } else {
                this.$toast('未获取到产品卡信息,请重新扫描产品卡！');
            }
        },
        // 删除产品卡
        deleteTransportTruckCards(index) {
            this.formData.TransportTruckCards.splice(index, 1);
            this.formData.ChoosedProductCards = this.formData.TransportTruckCards.map(item => item.ProductCardNumber);

            this.formData.DeliveryWeight = ((this.formData.TransportTruckCards || [])
                .map(item => item.PackageSingleWeight) || [])
                .reduce((pre, cur) => { return NP.plus(pre || 0, cur || 0); }, 0);
        },
        // 保存汽运发货单
        async handleSave() {
            if (this.formData.DeliveryWeightNew === null || this.formData.DeliveryWeightNew === '') {
                this.$toast('请先填发货数量！');
                return;
            }
            if ((this.formData.DeliveryTareWeight || 0) <= 0) {
                this.$toast('请先填进场皮重,并且不能为0！');
                return;
            }
            if ((this.formData.DeliveryGrossWeight || 0) <= 0) {
                this.$toast('请先填出场毛重,并且不能为0！');
                return;
            }
            if (this.formData.DeliveryGrossWeight < this.formData.DeliveryTareWeight) {
                this.$toast('出场毛重需要大于进场皮重！');
                return;
            }
            if ((this.formData.DeliveryNetWeight || 0) <= 0) {
                this.$toast('出场净重需要大于0！');
                return;
            }
            const res = await this.saveFormRequrst(this.formData);
            if (res) {
                this.formData.Id = res.Id;
                this.formData.TransportNumber = res.TransportNumber;
                this.isSaveOperation = true;
                this.$toast('保存成功！');
            }
        },
        // 提交
        async handleSubmit() {
            if ((this.formData.Id || '') === '') {
                this.$toast('请先保存汽运单！');
                return;
            }
            if (this.formData.TransportType === '2' && (this.formData.TransportTruckCards || []).length === 0) {
                this.$toast('请先添加产品卡！');
                return;
            }
            const res = await this.submitFormRequrst(this.formData.Id);
            if (res) {
                this.$toast.success('提交成功！');
                setTimeout(() => {
                    this.closeForm();
                    this.$router.go(-1);
                }, 1000);
            }
        },
        async confirmAppearance() {
            const res = await this.saveFormRequrst(this.formData);
            if (res) {
                this.formData.Id = res.Id;
                this.formData.TransportNumber = res.TransportNumber;
                this.isSaveOperation = true;
            } else {
                return;
            }
            this.$dialog.confirm({
                message: `确认发货单 \n${this.formData.TransportNumber}出场？`,
            }).then(async () => {
                const res = await this.appearanceRequrst(this.formData.Id);
                if (res) {
                    this.$toast.success('出场成功。');
                    setTimeout(() => {
                        this.closeForm();
                        this.$router.go(-1);
                    }, 1000);
                }
            });
        },
        closeForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
                params: {
                    isRefresh: true,
                },
            });
        },
        // 获取汽运单数据
        getFormDataRequrst_qy(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_truck_single?id=${id}`);
        },
        // 获取铁运单数据
        getFormDataRequrst_ty(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_railway_single_notice?id=${id}`);
        },
        // 获取产品卡信息
        getProductCardInfo(materialCode, productCardNumber) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_truck_check_card?materialCode=${materialCode}&productCardNumber=${productCardNumber}`);
        },
        // 保存表单请求
        saveFormRequrst(requestData) {
            return this.$axios.$post('/interfaceApi/sale/transport_manage/transport_truck_save', requestData);
        },
        // 提交表单请求
        submitFormRequrst(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_truck_submit?id=${id}`);
        },
        // 确认出场请求
        appearanceRequrst(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_truck_out?id=${id}`);
        },
    },
};
</script>
<style lang="stylus">
.automobileWaybillRegistrationForm
    height 100%
    background #F0F0F0
    .currencyTabsStyle
        flex 1
        height 0
        .van-tabs__content
            .van-tab__pane
                height 100%
                .commonListStyles
                    padding 14px
                    .listItem
                        flex-shrink: 0
                        overflow hidden
                        background #fff
                        margin-bottom 10rpx
                        position relative
                        border-radius 4rpx
                        border: 1px solid rgba(0, 0, 0, 0.1)
                .btns
                    position: absolute
                    bottom: 20rpx
                    right 20rpx
                    button
                        display: block
                        width: 44rpx;
                        height: 44rpx;
                        font-size 24rpx
                        margin-bottom: 20rpx
                        color #fff
                        border-radius: 50%
                        border: none
                        background: linear-gradient( 138deg, #EB6348 0%, #E93543 100%);
                        box-shadow: 0px 8rpx 8rpx 0px rgba(233, 53, 67, 0.2);
</style>
